module.exports = __webpack_public_path__ + "img/aiben-icon.3634bf7a.png";